import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Harbour } from '@models';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input'

@Component({
  selector: 'app-vessel-harbour-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  imports: [
    MatButtonModule,
    MatInputModule,
    MatDialogModule,
    ReactiveFormsModule,
  ],
})
export class VesselHarbourFormComponent {
  isEdit = signal<boolean>(false);
  dialogRef = inject<MatDialogRef<VesselHarbourFormComponent>>(MatDialogRef);

  place = new FormControl('', { validators:[Validators.required] });
  country = new FormControl('', {});
  harbourForm = new FormGroup({
    place: this.place,
    country: this.country,
  });

  constructor() {
    const harbour = inject<Harbour>(MAT_DIALOG_DATA);

    this.isEdit.set(!!harbour);

    if (harbour) {
      if (harbour.place) {
        this.place.setValue(harbour.place);
      }
      if (harbour.country) {
        this.country.setValue(harbour.country);
      }
    }
  }

  submit() {
    if (this.harbourForm.pristine || !this.harbourForm.valid) { return };

    const data = {
      place: this.harbourForm.value.place,
      country: this.harbourForm.value.country ? this.harbourForm.value.country : undefined,
    } as Harbour;

    this.dialogRef.close(data);
  }

  cancel() {
    this.dialogRef.close();
  }
}
